import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { api } from "@/lib/api";
import { Reveal } from "./motion";

export default function Gallery() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/gallery").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  const spanClass = (span) => {
    if (span === "tall") return "md:row-span-2 md:col-span-1";
    if (span === "wide") return "md:col-span-2";
    return "";
  };

  return (
    <section id="gallery" className="py-24 md:py-36 bg-white border-t border-steel-200">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <Reveal className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div>
            <p className="font-label text-xs tracking-[0.3em] uppercase text-steel-500 mb-4">Recent work</p>
            <h2 className="font-display font-black tracking-tighter text-steel-900 text-4xl md:text-6xl leading-none">
              Real balconies.<br /><span className="text-steel-400">Real Hyderabad.</span>
            </h2>
          </div>
          <p className="text-steel-600 max-w-sm">Every project is measured, installed and tension-tested by our own team — no subcontractors.</p>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 auto-rows-[260px] gap-4" data-testid="gallery-grid">
          {items.map((g, i) => (
            <motion.div
              key={g.id}
              initial={{ opacity: 0, scale: 0.96 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: (i % 3) * 0.08, ease: [0.22, 1, 0.36, 1] }}
              className={`group relative overflow-hidden border border-steel-200 ${spanClass(g.span)}`}
              data-testid={`gallery-item-${i}`}
            >
              <img src={g.image_url} alt={`${g.title} — invisible grills installed in ${g.location}, Hyderabad`} loading="lazy" decoding="async" width={900} height={700} className="w-full h-full object-cover grayscale-[0.15] group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700" />
              <div className="absolute inset-0 bg-gradient-to-t from-steel-900/75 via-transparent to-transparent opacity-90" />
              <div className="absolute bottom-0 inset-x-0 p-5">
                <div className="font-label text-[10px] uppercase tracking-[0.2em] text-steel-200">{g.location}</div>
                <div className="font-display font-bold text-white text-lg leading-tight">{g.title}</div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
